import * as React from "react";

interface Props {
    type: string,
    text: string,
    style: string,
    onClick?: any
}

interface State {

}

export default class FormButton extends React.Component<Props, State> {
    constructor(props) {
        super(props);
    }

    render() {

        console.log('danilo', this.props.style);

        return (
            <button type={this.props.type} className="btn btn-orange btn-blue" onClick={this.props.onClick} >{ this.props.text }</button>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/ui/FormButton.tsx